import { useState } from "react";

import { PinModal, useCan, useSelectedDealer } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import {
  CreateManufacturerRequestModal,
  ManufacturerDashboardFilter,
  ManufacturerRequestModal,
  ManufacturerSearch,
  ManufacturerTable
} from "modules/ManufacturerDashboard/components";
import { useAddManufacturerPinMutation, useCreateManufacturerRequestModal } from "modules/ManufacturerDashboard/hooks";
import "modules/ManufacturerDashboard/ManufacturerDashboard.scss";

import type { ManufacturerRequest, Pin } from "models";

export const ManufacturerDashboard = () => {
  const [selectedPinItem, setSelectedPinItem] = useState<Pin[] | null>(null);
  const [selectedRequest, setSelectedRequest] = useState<ManufacturerRequest | null>(null);

  const closePinModal = () => setSelectedPinItem(null);
  const selectPinItem = (pinItem: Pin[] | null) => setSelectedPinItem(pinItem);

  const { mutateAsync: addManufacturerPin, isPending } = useAddManufacturerPinMutation();
  const { showCreateRequestModal, closeCreateRequestModal, openCreateRequestModal, searchManufacturerClaim, pinClaims, isSearchingPin } =
    useCreateManufacturerRequestModal();
  const { selectedDealer } = useSelectedDealer();
  const canCreateFullPin = useCan(ACL_ACTIVITIES.Create, ACL_RESOURCES.PinFull);

  const latestPinHistory = selectedPinItem?.at(0);

  const handleSavePin = async (payload: Pin) => {
    if (!canCreateFullPin) return;
    await addManufacturerPin(payload);
  };

  return (
    <div className="Manufacturer__container">
      <ManufacturerSearch />
      <ManufacturerDashboardFilter onOpenRequestModal={openCreateRequestModal} />
      <ManufacturerTable openRequestModal={setSelectedRequest} onSelectPinItem={selectPinItem} />
      <ManufacturerRequestModal onCloseModal={() => setSelectedRequest(null)} selectedRequest={selectedRequest} />

      {latestPinHistory && (
        <PinModal
          onSavePin={handleSavePin}
          isSavingPin={isPending}
          pin={{ ...latestPinHistory, history: selectedPinItem ?? [] }}
          dealer={selectedDealer}
          isOpen={Boolean(selectedPinItem)}
          onClose={closePinModal}
        />
      )}

      {showCreateRequestModal && (
        <CreateManufacturerRequestModal
          onCloseModal={closeCreateRequestModal}
          onSearchClaim={searchManufacturerClaim}
          claimResults={pinClaims}
          isLoading={isSearchingPin}
        />
      )}
    </div>
  );
};
